module.exports = __webpack_public_path__ + "about-mobile.jpg?6e3bab6c1f6f236795013871e9fe75d8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-mobile.jpg
// module id = 246
// module chunks = 0